import { useNavigate } from 'react-router-dom';
import { Lock, LayoutDashboard, MessageCircle } from 'lucide-react';
import MainLayout from '../components/Layout/MainLayout';

/**
 * Shown at /off-market-stays when the advisor is signed in but does not have hasOffMarketAccess.
 */
const OffMarketAccessBlockedPage = () => {
    const navigate = useNavigate();

    return (
        <MainLayout>
            <div className="flex-1 flex flex-col items-center justify-center px-4 py-16 pt-28 md:pt-32 pb-20 bg-gradient-to-b from-neutral-100 to-neutral-50 min-h-[70vh]">
                <div className="w-full max-w-lg rounded-2xl border border-neutral-200/80 bg-white shadow-xl shadow-neutral-900/5 p-8 sm:p-10 text-center">
                    <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-amber-100 to-yellow-50 border border-amber-200/60 ring-1 ring-neutral-900/5">
                        <Lock className="h-8 w-8 text-amber-700" aria-hidden />
                    </div>
                    <h1 className="text-xl sm:text-2xl font-bold text-neutral-900 tracking-tight">
                        Off-market stays
                    </h1>
                    <p className="mt-2 text-sm font-semibold uppercase tracking-widest text-amber-700/90">
                        Access required
                    </p>
                    <p className="mt-4 text-sm sm:text-base text-neutral-600 leading-relaxed">
                        This catalogue is limited to advisors who have been granted off-market access on their account.
                        If you believe you should have access, please contact your Axonall administrator or support.
                    </p>
                    <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:justify-center sm:items-stretch">
                        <button
                            type="button"
                            onClick={() => navigate('/dashboard')}
                            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-xl bg-neutral-900 px-6 py-3 text-sm font-semibold text-white hover:bg-neutral-800 transition-colors"
                        >
                            <LayoutDashboard className="h-4 w-4" aria-hidden />
                            Back to dashboard
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate('/contact')}
                            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-xl border border-neutral-300 bg-white px-6 py-3 text-sm font-semibold text-neutral-800 hover:bg-neutral-50 transition-colors"
                        >
                            <MessageCircle className="h-4 w-4" aria-hidden />
                            Contact us
                        </button>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default OffMarketAccessBlockedPage;
